/// <amd-module name="Artifacts/Root/containers/ModalManager" />
import { IRootModuleState } from "Artifacts/Root/redux/Contracts";
import * as React from "react";
import { connect } from "react-redux";

const modals: Record<string, React.ComponentType<any>> = {};

export function registerModal(modalName: string, component: React.ComponentType<any>): void {
  modals[modalName] = component;
}

const ModalManager: React.FC<IModalManagerMapStateToProps> = ({ modal, modalProps }) => {
  if (modal == null) {
    return null;
  }

  const Component = modals[modal];
  return <Component {...modalProps} />;
};

interface IModalManagerMapStateToProps {
  modal?: string;
  modalProps?: Record<string, any>;
}

const mapStateToProps = (state: IRootModuleState): IModalManagerMapStateToProps => {
  return {
    modal: state.rootState.modal?.modalId,
    modalProps: state.rootState.modal?.props,
  };
};

const ConnectedModalManager = connect(mapStateToProps, {})(ModalManager);

export { ConnectedModalManager as ModalManager };
